import React from "react";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";
import update from "immutability-helper";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import AppModal from "../../../Components/Models/app-modal";
import { Form, Button, InputGroup, FormControl } from "react-bootstrap";
import api from "../../../Services/Api/api";

const SCREEN_NAME = "EDIT_CUSTOMER_SCREEN";

class EditCustomerInner extends AppComponent {
  state = {
    firstName: this.props.customer?.firstName || "",
    lastName: this.props.customer?.lastName || "",
    countryCode: this.props.customer?.countryCode || "91",
    phone: this.props.customer?.phone || "",
    email: this.props.customer?.email || "",
    address: this.props.customer?.address || "",
    introducer: this.props.customer?.introducer,
  };

  formRef = React.createRef(null);

  async onSubmit() {
    try {
      if (this.state.loading) return;
      const isValid = this.formRef?.current?.reportValidity();
      if (!isValid) return;

      this.setAsyncState({ loading: true, error: null });
      const payload = _.pick(this.state, [
        "firstName",
        "lastName",
        "countryCode",
        "phone",
        "email",
        "address",
        "introducer",
      ]);

      let res = null;
      if (this.props.customer?._id) {
        res = await api.patch(
          `v1/customer/${this.props.customer._id}`,
          payload
        );
      } else {
        res = await api.post("v1/customer", payload);
      }

      this.setAsyncState({ loading: false });
      this.props.onSubmit(res);
    } catch (e) {
      this.setAsyncState({ error: e.message, loading: false });
    }
  }

  renderForm() {
    const {
      props: { renderModal = false },
      state: {
        firstName,
        lastName,
        phone,
        countryCode,
        email,
        address,
        introducer,
        error,
      },
    } = this;

    return (
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          this.onSubmit();
        }}
        ref={this.formRef}
      >
        <Form.Group className="mb-3">
          <Form.Label>First Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => this.setAsyncState({ firstName: e.target.value })}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => this.setAsyncState({ lastName: e.target.value })}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Phone Number</Form.Label>
          <InputGroup className="mb-3">
            <FormControl
              type="number"
              aria-label="Country Code"
              style={{ maxWidth: "8rem" }}
              placeholder="Country Code"
              value={countryCode}
              onChange={(e) =>
                this.setAsyncState({ countryCode: e.target.value.trim() })
              }
            />
            <FormControl
              type="number"
              aria-label="Phone Number"
              placeholder="Phone Number"
              value={phone}
              onChange={(e) =>
                this.setAsyncState({ phone: e.target.value.trim() })
              }
            />
          </InputGroup>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => this.setAsyncState({ email: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Address</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Address"
            value={address}
            onChange={(e) => this.setAsyncState({ address: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Introducer</Form.Label>
          <Form.Control
            placeholder="Introducer"
            value={introducer?.description || ""}
            onChange={(e) =>
              this.setAsyncState({
                introducer: update(this.state.introducer || {}, {
                  $merge: { description: e.target.value },
                }),
              })
            }
          />
        </Form.Group>

        <div className="errormsg">{error}</div>

        {renderModal ? null : (
          <Button variant="primary" type="submit">
            Submit
          </Button>
        )}
      </Form>
    );
  }

  renderModal() {
    return (
      <AppModal
        {...{
          visible: this.props.visible,
          handleClose: this.props.handleClose,
          title: this.props.customer?._id
            ? "Edit Customer"
            : "Add New Customer",
          onSubmit: this.onSubmit.bind(this),
          disableSubmit: this.state.loading,
        }}
      >
        {this.renderForm()}
      </AppModal>
    );
  }

  render() {
    const {
      props: { renderModal = false },
    } = this;

    if (renderModal) return this.renderModal();
    else return this.renderForm();
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const EditCustomer = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditCustomerInner);

export default EditCustomer;
